import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  DataService as CoreDataService,
  ObjectKey,
  PersistenceService,
  PersistMode,
  PersistObjectModel,
  PersistObjectsModel,
  QueryColumnSortOrder,
  TargetColumnValue,
  TargetObjectData,
} from "@barthauer/abc/core/data";
import {
  Measure,
  NotificationMessage,
  Person,
  SubProject,
  ToastType,
} from "@barthauer/custom/xmt-models";

import { _AbcFormComponent } from "@barthauer/abc/ui-components";
import {
  DxCheckBoxModule,
  DxDateBoxModule,
  DxFormModule,
  DxHtmlEditorComponent,
  DxSelectBoxModule,
  DxTagBoxModule,
  DxTextAreaModule,
  DxTextBoxModule,
} from "devextreme-angular";
import {
  finalize,
  forkJoin,
  from,
  map,
  Observable,
  of,
  Subscription,
  switchMap,
} from "rxjs";
import { AppService } from "../../../services/app.service";
import { DataService, ObjectKeys } from "../../../services/data.service";
import { NotificationService } from "../../../services/notification.service";
import { SharedModule } from "../../../shared/shared.module";
import { MeasureService } from "../measure.service";
import { BasedRoleOPathService } from "../../../services/based-role-opath.service";
import {
  EmailNotificationDescriptions,
  EmailNotificationSubjects,
  EmailNotificationType,
  INotificationRecord,
  NotificationService1,
} from "../../../services/notification1.service";
import { AIMSROUTES } from "../../../../app-routing.module";
import { LanguageService } from "../../../services/language.service";
import { ObjectTypeService } from "../../../services/object-type.service";

@Component({
  selector: "ubt-geods-create-measure",
  templateUrl: "./create-measure.component.html",
  styleUrls: ["./create-measure.component.scss"],
  imports: [
    _AbcFormComponent,
    DxFormModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxCheckBoxModule,
    DxTextAreaModule,
    DxTagBoxModule,
    DxDateBoxModule,
    SharedModule,
  ],
})
export class CreateMeasureComponent implements OnInit, OnDestroy {
  @ViewChild("form") form: _AbcFormComponent;
  @ViewChild("htmlEditor") htmlEditor: DxHtmlEditorComponent;

  @Output() closePopup: EventEmitter<any> = new EventEmitter();
  public measure: Measure = new Measure(null);
  public subProject: SubProject = new SubProject(null);
  public createSecondMeasure = false;
  public staffmembers: Person[] = [];
  public responsibles: Observable<Person[]>;
  public subProjects: SubProject[] = [];
  public toogleTitleVisible = false;
  public propertyName: string;
  public fieldValue: string;
  public currentDescriptionField: string;
  public createButtonOptions = {
    text: this.dataService.res("Ubt-CreateMeasure-Create"),
    onClick: () => (this._goToDetail = false),
    useSubmitBehavior: true,
  };
  public createAndOpenDetailsButtonOptions = {
    text: this.dataService.res("Ubt-CreateMeasure-Create-And-Open"),
    onClick: () => (this._goToDetail = true),
    useSubmitBehavior: true,
  };
  public cancelButtonOptions = {
    text: this.dataService.res("Ubt-CreateMeasure-Cancel"),
    onClick: () => this.cancel(),
  };
  private subscriptions: Subscription[] = [];
  private _goToDetail: boolean;

  constructor(
    private coreDataService: CoreDataService,
    public dataService: DataService,
    public measureService: MeasureService,
    private router: Router,
    private persistenceService: PersistenceService,
    private notificationService: NotificationService,
    private notificationService1: NotificationService1,
    private cdr: ChangeDetectorRef,
    public appService: AppService,
    public baseRoleOpath: BasedRoleOPathService,
    private languageService: LanguageService,
    private objectTypeService: ObjectTypeService,
  ) {}

  public ngOnInit(): void {
    this.measure = new Measure(null);
    const subProjectColumns = [
      this.coreDataService.createQueryColumn(
        "Id",
        "Id",
        QueryColumnSortOrder.None,
      ),
      this.coreDataService.createQueryColumn(
        "Designation",
        "Label",
        QueryColumnSortOrder.None,
      ),
    ];
    const subProjectOPath = this.baseRoleOpath.checkSubprojectOPath();
    this.subscriptions.push(
      this.dataService
        .readObjects<
          SubProject[]
        >(ObjectKeys.SUBPROJECT, subProjectColumns, subProjectOPath)
        .subscribe((subProjects: any) => {
          this.subProjects = subProjects.sort((a, b) =>
            a.Label.localeCompare(b.Label),
          );
        }),
    );
  }
  handlePaste(event: any, fieldValue: string, propertyField?: string): void {
    if (event.event) {
      if (event.event.originalEvent.type === "paste") {
        const sanitizedContent = this.appService.sanitizeContent(
          fieldValue,
          true,
        );
        this.measure[propertyField] = sanitizedContent;
        this.currentDescriptionField = this.measure[propertyField];
        this.htmlEditor.value = sanitizedContent;
      }
    } else {
      this.currentDescriptionField = fieldValue;
    }
  }
  public onValueChanged = (e) => {
    const subProjectId = e.value;
    this.getSubProjectById(subProjectId);
  };

  private getSubProjectById = (subProjectId: string) => {
    const subProjectColumns = [
      this.coreDataService.createQueryColumn(
        "Id",
        "Id",
        QueryColumnSortOrder.None,
      ),
      this.coreDataService.createQueryColumn(
        "StartDate",
        "StartDate",
        QueryColumnSortOrder.None,
      ),
      this.coreDataService.createQueryColumn(
        "EndDate",
        "EndDate",
        QueryColumnSortOrder.None,
      ),
    ];
    const subProjectOPath = "Id=" + "'" + subProjectId + "'";
    this.subscriptions.push(
      this.dataService
        .readObjects<
          SubProject[]
        >(ObjectKeys.SUBPROJECT, subProjectColumns, subProjectOPath)
        .subscribe((subProjects) => {
          this.subProject = subProjects[0];
        }),
    );
  };

  public createMeasure(event: Event): void {
    event.preventDefault();

    const persistObject = this.buildMeasurePersistObject();
    this.subscriptions.push(
      this.persistenceService
        .executePersistObjectQuery(persistObject)
        .pipe(
          map((data) => data as unknown as Measure),
          switchMap((data) =>
            this.notificationService1
              .getNotificationSettings(this.measure.Responsible?.toString())
              .pipe(
                map((types) =>
                  this.notificationService1.parseNotificationSettings(types),
                ),
                switchMap((settings) => {
                  const measureId = data.Id;
                  this.dataService.updateGridData(data);
                  this.assignResourcesToMeasure(measureId);
                  return this.notifyResponsibleAssigned(
                    measureId,
                    this.measure.Responsible?.toString(),
                    this.measure.Title,
                    settings,
                  ).pipe(map(() => data));
                }),
              ),
          ),
          finalize(() => {
            this.measure = new Measure(null);
          }),
        )
        .subscribe({
          next: (data) => {
            this.notificationService.callNotification({
              message: NotificationMessage.ValidInsertMessage,
              type: ToastType.SUCCESS,
            });

            if (this._goToDetail) {
              this.closePopup.emit({
                isNavigateTomeasureDetail: true,
                measureId: data.Id,
              });
              this.dataService.sendMeasureDetail(data);
              this.dataService.appService.showMeasureIcon = true;
            } else if (this.createSecondMeasure) {
              this.measure = new Measure(null);
            } else {
              this.closePopup.emit({
                isNavigateTomeasureDetail: false,
                measureId: data.Id,
              });
            }
          },
          error: () => {
            this.notificationService.callNotification({
              message: NotificationMessage.Error,
              type: ToastType.ERROR,
            });
          },
        }),
    );
  }

  private buildMeasurePersistObject(): PersistObjectModel {
    const measurePersistQuery = new TargetObjectData();
    measurePersistQuery.ObjectKey = new ObjectKey();
    measurePersistQuery.ObjectKey.ObjectType = ObjectKeys.MEASURE;
    measurePersistQuery.Mode = PersistMode.Insert;
    measurePersistQuery.TargetColumns = [
      { Name: "ParentId", Value: this.measure.SubProject?.toString() },
      { Name: "Designation", Value: this.measure.Title },
      { Name: "StartDate", Value: this.measure.StartDate?.toDateString() },
      { Name: "EndDate", Value: this.measure.EndDate?.toDateString() },
      {
        Name: "IdRefPersonResponsible",
        Value: this.measure.Responsible?.toString(),
      },
      {
        Name: "IdRefPersonAreaManager",
        Value: this.measure.AreaManager?.toString(),
      },
      { Name: "InitialSituation", Value: this.measure.InitialSituation },
      { Name: "Goal", Value: this.measure.Goal },
      { Name: "Concept", Value: this.measure.Concept },
      { Name: "DefenseMeasures", Value: this.measure.DefenseMeasures },
      { Name: "Dependencies", Value: this.measure.Dependencies },
      { Name: "ExpectedResults", Value: this.measure.ExpectedResults },
      {
        Name: "CurrentGrade",
        Value: this.measureService.maturityLevel[0].name,
      },
      { Name: "Status", Value: this.measureService.measureStatus[2].value },
    ];
    const persistObject = new PersistObjectModel();
    persistObject.Object = measurePersistQuery;
    return persistObject;
  }

  private notifyResponsibleAssigned(
    measureId: string,
    responsibleId: string,
    title: string,
    settings: {
      notificationByEmail: boolean;
      notificationInApp: boolean;
      language: string;
    },
  ): Observable<any> {
    const inApp$ = settings.notificationInApp
      ? (() => {
          const notificationRecords: INotificationRecord[] = [
            {
              ParentId: measureId,
              ParentObjectType: this.objectTypeService.getObjectTypesValue(ObjectKeys.MEASURE),
              Comment: "notification.Measure-UserAssigned",
              Text: "",
              UserIdList: [responsibleId],
            },
          ];
          return this.measureService.createNotifications(notificationRecords);
        })()
      : of(null);

    const email$ = settings.notificationByEmail
      ? this.dataService
          .readObjects(
            ObjectKeys.PERSON,
            [
              this.coreDataService.createQueryColumn("Id", "Id"),
              this.coreDataService.createQueryColumn(
                "EMail",
                "EMail",
                QueryColumnSortOrder.None,
              ),
            ],
            `Id='${responsibleId}'`,
          )
          .pipe(
            switchMap((persons: any[]) => {
              const email = persons?.[0]?.EMail;

              if (!email) {
                return of(null);
              }

              return from(
                this.languageService.translateBulk(
                  [
                    {
                      field: "subject",
                      key: EmailNotificationSubjects.MEASURE_USER_ASSIGNED,
                    },
                    {
                      field: "description",
                      key: EmailNotificationDescriptions.MEASURE_USER_ASSIGNED,
                      params: { 0: title },
                    },
                    {
                      field: "notificationType",
                      key: EmailNotificationType.MEASURE_USER_ASSIGNED,
                    },
                  ],
                  settings.language,
                ),
              ).pipe(
                switchMap((translations) => {
                  const redirectUrl = this.dataService.generateRedirectionUrl(
                    AIMSROUTES.MEASURE_DETAIL,
                    [AIMSROUTES.MEASURES, measureId],
                  );

                  const content = {
                    notificationType: translations.notificationType,
                    description: translations.description,
                    redirectUrl,
                  };

                  return this.notificationService1.sendNotificationEmail(
                    content,
                    translations.subject,
                    email,
                    settings.language,
                  );
                }),
              );
            }),
          )
      : of(null);
    return forkJoin([inApp$, email$]);
  }

  private assignResourcesToMeasure(measureId: string) {
    const query: PersistObjectsModel = new PersistObjectsModel();
    const resourcePersistQuery: TargetObjectData[][] = [[]];
    this.measure.MeasureResources?.forEach((resource) => {
      const reourcesPersistObjectData: TargetObjectData =
        new TargetObjectData();
      reourcesPersistObjectData.Mode = PersistMode.Insert;
      reourcesPersistObjectData.ObjectKey = new ObjectKey();
      reourcesPersistObjectData.ObjectKey.ObjectType = ObjectKeys.RESOURCE;
      const resourceColumns: TargetColumnValue[] = [
        { Name: "ParentId", Value: measureId },
        { Name: "IdRefPerson", Value: resource.toString() },
      ];
      reourcesPersistObjectData.TargetColumns = resourceColumns;
      resourcePersistQuery[0].push(reourcesPersistObjectData);
    });
    query.Objects = resourcePersistQuery;
    this.persistenceService.executePersistObjectsQuery(query).subscribe();
  }

  public verifyChanges(fieldValue): void {
    this.currentDescriptionField = fieldValue;
  }

  public openPopup(fieldValue: string, propertyName: string): void {
    this.propertyName = propertyName;
    this.htmlEditor.value = fieldValue;
    this.toogleTitleVisible = true;
    this.cdr.markForCheck();
  }

  public saveChanges(propertyName: string, fieldValue: string) {
    this.measure[propertyName] = fieldValue;
    this.toogleTitleVisible = false;
  }

  public cancel(): void {
    this.closePopup.emit(this.createSecondMeasure === true ? false : true);
    this.form.instance.resetValues();
    this.measure = new Measure(null);
    this.createSecondMeasure = false;
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
